import EmblaCarousel from 'components/carousel2025/EmblaCarousel';
import useEmblaCarousel from 'embla-carousel-react';
import { PerkItem } from './YourPerks';
import styles from './YourPerksCarousel.module.css';
import { filterPerksByTestGroup } from './constants';

export const YourPerksCarousel = ({
  isInMonthlyTestGroup,
}: {
  isInMonthlyTestGroup: boolean;
}) => {
  const emblaCarouselInfo = useEmblaCarousel({
    loop: true,
  });

  return (
    <EmblaCarousel
      className={styles.perksCarousel}
      emblaCarouselInfo={emblaCarouselInfo}
      items={filterPerksByTestGroup(isInMonthlyTestGroup).map((perk, i) => (
        <PerkItem key={i} {...perk} />
      ))}
    />
  );
};
